import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Año académico", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "floatingInput"
}, "Número período", -1)
const _hoisted_7 = { class: "mb-15 mb-md-20" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "floatingInput"
}, "Descripción", -1)
const _hoisted_9 = { class: "mb-15 mb-md-20" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "floatingInputdateFrom"
}, "Fecha inicial", -1)
const _hoisted_11 = { class: "mb-15 mb-md-20" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "floatingInputDateTo"
}, "Fecha final", -1)
const _hoisted_13 = { class: "mb-15 mb-md-20" }
const _hoisted_14 = { class: "form-floating mb-15 mb-md-20" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "floatingInputDateTo"
}, "Abierto desde", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "floatingInputDateTo"
}, "Abierto hasta", -1)
const _hoisted_17 = { class: "mb-15 mb-md-20" }
const _hoisted_18 = { class: "form-floating mb-15 mb-md-20" }
const _hoisted_19 = { class: "form-floating mb-15 mb-md-20" }
const _hoisted_20 = { class: "d-sm-flex align-items-center" }
const _hoisted_21 = { class: "search-box position-relative" }
const _hoisted_22 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_23 = { class: "table-responsive" }
const _hoisted_24 = { class: "text-center text-success my-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("strong", null, " Cargando...", -1)
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen p-2" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_32 = { class: "mb-0 text-paragraph" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "10", -1)
const _hoisted_34 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_TableAuditColumns = _resolveComponent("TableAuditColumns")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_pagination = _resolveComponent("b-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_b_button, {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
          type: "button",
          onClick: _ctx.openModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Nuevo período "),
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_b_modal, {
          class: "modal fade",
          modelValue: _ctx.form.dialog,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.dialog) = $event)),
          tabindex: "-1",
          "aria-hidden": "true",
          title: _ctx.form.record.Id > 0 ? `${_ctx.form.record.Description}` : `Nueva período`,
          "ok-disabled": "",
          "hide-footer": true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_container, { class: "bv-example-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form, {
                  ref: "formRecord",
                  id: "formModal",
                  onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_5,
                                _createVNode(_component_SearchSelect, {
                                  modelValue: _ctx.form.record.AcademicYearId,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.AcademicYearId) = $event)),
                                  required: "",
                                  "was-validated": _ctx.form.valid,
                                  loading: _ctx.table.loading,
                                  disabled: _ctx.canEdit,
                                  options: _ctx.academicYears.map(r => ({ value: r.Id, text: `Año ${r.Year} - Período: ${r.StartDate.substring(0, 10)} Hasta ${r.EndDate.substring(0, 10)}` })),
                                  placeholder: "Seleccione el año académico"
                                }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_6,
                                _createElementVNode("div", _hoisted_7, [
                                  _createVNode(_component_b_form_select, {
                                    class: "form-select form-select-sm shadow-none fs-14 text-black",
                                    id: "input-type",
                                    modelValue: _ctx.form.record.PeriodNumber,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.PeriodNumber) = $event)),
                                    placeholder: "Seleccione el período a crear",
                                    required: "",
                                    disabled: _ctx.canEdit,
                                    options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
                                  }, null, 8, ["modelValue", "disabled"]),
                                  _createVNode(_component_b_form_invalid_feedback, { id: "input-1-live-feedback" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Campo requerido")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_8,
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_b_form_input, {
                                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                                    id: "floatingInput",
                                    modelValue: _ctx.form.record.Description,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.Description) = $event)),
                                    placeholder: "Ingrese la descripción del período",
                                    required: "",
                                    type: "text"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_b_form_invalid_feedback, { id: "input-1-live-feedback" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Campo requerido")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_10,
                                _createElementVNode("div", _hoisted_11, [
                                  _createVNode(_component_b_form_input, {
                                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                                    id: "floatingInputdateFrom",
                                    modelValue: _ctx.form.record.DateFrom,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.DateFrom) = $event)),
                                    placeholder: "Seleccione la fecha inicial del período",
                                    required: "",
                                    type: "date"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_b_form_invalid_feedback, { id: "input-1-live-feedback" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Campo requerido")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_12,
                                _createElementVNode("div", _hoisted_13, [
                                  _createVNode(_component_b_form_input, {
                                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                                    id: "floatingInputDateTo",
                                    modelValue: _ctx.form.record.DateTo,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.DateTo) = $event)),
                                    placeholder: "Seleccione la fecha final del período",
                                    required: "",
                                    type: "date"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_b_form_invalid_feedback, { id: "input-1-live-feedback" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Campo requerido")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_14, [
                                  _createVNode(_component_b_form_checkbox, {
                                    id: "checkbox-enable",
                                    modelValue: _ctx.form.record.IsOpen,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.IsOpen) = $event)),
                                    name: "checkbox-enable"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Registro académico abierto ")
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_15,
                                _createVNode(_component_b_form_input, {
                                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                                  id: "floatingInputDateTo",
                                  modelValue: _ctx.form.record.OpenFrom,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.record.OpenFrom) = $event)),
                                  placeholder: "Seleccione la fecha hasta",
                                  required: "",
                                  type: "time"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.form.record.IsOpen)
                          ? (_openBlock(), _createBlock(_component_b_col, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_b_form_group, null, {
                                  default: _withCtx(() => [
                                    _hoisted_16,
                                    _createElementVNode("div", _hoisted_17, [
                                      _createVNode(_component_b_form_input, {
                                        class: "form-control fs-14 text-black shadow-none form-control-sm",
                                        id: "floatingInputDateTo",
                                        modelValue: _ctx.form.record.OpenTo,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.record.OpenTo) = $event)),
                                        placeholder: "Seleccione la fecha hasta",
                                        required: "",
                                        type: "time"
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_b_form_invalid_feedback, { id: "input-1-live-feedback" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Campo requerido")
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_b_form_checkbox, {
                                    id: "checkbox-enable",
                                    modelValue: _ctx.form.record.CurrentPeriod,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.record.CurrentPeriod) = $event)),
                                    name: "checkbox-enable"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Período actual ")
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_b_form_checkbox, {
                                    id: "checkbox-enable",
                                    modelValue: _ctx.form.record.Enable,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.record.Enable) = $event)),
                                    name: "checkbox-enable"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Activo ")
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_button, {
                              type: "submit",
                              class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Guardar")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("form", _hoisted_21, [
          _createVNode(_component_b_form_input, {
            modelValue: _ctx.table.filters.search,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.table.filters.search) = $event)),
            class: "search-box position-relative form-control shadow-none text-black rounded-0 border-0",
            type: "search",
            placeholder: "Buscar..."
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_b_table, {
          id: "tableList",
          class: "table text-nowrap align-middle mb-0",
          striped: "",
          hover: "",
          "sticky-header": "",
          small: "",
          keyword: _ctx.table.filters.search,
          busy: _ctx.table.loading,
          items: _ctx.filteredItems,
          fields: _ctx.table.headers,
          "per-page": _ctx.table.rowsPerPage,
          "current-page": _ctx.table.currentPage
        }, {
          "table-busy": _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_b_spinner, { class: "align-middle" }),
              _hoisted_25
            ])
          ]),
          "cell(AcademicYearName)": _withCtx(({ item }) => [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.edit(item)),
              class: "cursor-pointer text-black fw-bold text-decoration-none"
            }, _toDisplayString(item.AcademicYearName), 9, _hoisted_26)
          ]),
          "cell(Description)": _withCtx(({ item }) => [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.edit(item)),
              class: "cursor-pointer text-black fw-bold text-decoration-none"
            }, _toDisplayString(item.Description), 9, _hoisted_27)
          ]),
          "cell(CurrentPeriod)": _withCtx(({ item }) => [
            _createVNode(_component_b_form_checkbox, {
              modelValue: item.CurrentPeriod,
              "onUpdate:modelValue": ($event: any) => ((item.CurrentPeriod) = $event),
              name: "checkbox-enable",
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          "cell(IsOpen)": _withCtx(({ item }) => [
            _createVNode(_component_b_form_checkbox, {
              modelValue: item.IsOpen,
              "onUpdate:modelValue": ($event: any) => ((item.IsOpen) = $event),
              name: "checkbox-enable",
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          "cell(Enable)": _withCtx(({ item }) => [
            _createVNode(_component_b_form_checkbox, {
              modelValue: item.Enable,
              "onUpdate:modelValue": ($event: any) => ((item.Enable) = $event),
              name: "checkbox-enable",
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          "cell(CreatedByFormat)": _withCtx(({ item }) => [
            _createVNode(_component_TableAuditColumns, {
              item: item,
              mode: "created"
            }, null, 8, ["item"])
          ]),
          "cell(ModifiedByFormat)": _withCtx(({ item }) => [
            _createVNode(_component_TableAuditColumns, {
              item: item,
              mode: "modified"
            }, null, 8, ["item"])
          ]),
          "cell(action)": _withCtx(({ item }) => [
            _createElementVNode("button", {
              type: "button",
              onClick: ($event: any) => (_ctx.edit(item)),
              class: "bg-transparent p-0 border-0 text-paragraph fs-15 fs-md-16 fs-lg-18"
            }, _hoisted_30, 8, _hoisted_28)
          ]),
          _: 1
        }, 8, ["keyword", "busy", "items", "fields", "per-page", "current-page"]),
        _createVNode(_component_b_pagination, {
          modelValue: _ctx.table.currentPage,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.table.currentPage) = $event)),
          "current-page": _ctx.table.currentPage,
          "per-page": _ctx.table.rowsPerPage,
          "aria-controls": "tableList",
          "total-rows": _ctx.rows,
          class: "mt-3"
        }, null, 8, ["modelValue", "current-page", "per-page", "total-rows"])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("p", _hoisted_32, [
          _createTextVNode(" Mostrando "),
          _hoisted_33,
          _createTextVNode(" de "),
          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.table.records.length), 1),
          _createTextVNode(" resultados ")
        ])
      ])
    ])
  ]))
}